import { ServiceTypes } from 'constants/ServiceTypes';
import { observer } from 'mobx-react-lite';
import React from 'react';
import {
  formatSectionCountLabel,
  formatSectionsDescription,
  getEnabledPlaneLocations,
} from 'services/helper-services/strikeZonePlanes';
import { useInjection } from 'services/ioc/ioc.react';
import { LineupStore } from 'stores/LineupStore';
import { PLANE_DEFINITIONS } from './planeDefinitions';
import { PlaneRow } from './PlaneRow';
import {
  Description,
  PlaneList,
  PlaneSummary,
  PlaneSummaryDescription,
  PlaneSummaryTitle,
  PlaneVisualization,
  StrikeZoneCalculationWrapper,
  Title,
  Wrapper,
} from './StrikeZoneCalculationStyles';
import { StrikeZonePlanesGraphic } from './StrikeZonePlanesGraphic';

export const StrikeZoneCalculation: React.FC = observer(() => {
  const lineupStore = useInjection<LineupStore>(ServiceTypes.LineupStore);
  const enabledPlanes = getEnabledPlaneLocations(lineupStore.planeConfiguration);

  return (
    <StrikeZoneCalculationWrapper data-testid='strike-zone-calculation'>
      <Title>Strike Zone Plane Configuration</Title>
      <Description>
        Select one or more strike zone planes to use to determine pitches. Add a negative offset to the height of the middle or back if
        needed.
      </Description>
      <Wrapper>
        <PlaneList>
          {PLANE_DEFINITIONS.map((definition) => {
            const plane = lineupStore.planeConfiguration.find((item) => item.locationType === definition.locationType);

            if (!plane) {
              return null;
            }

            return <PlaneRow key={definition.locationType} definition={definition} plane={plane} />;
          })}
        </PlaneList>
        <PlaneVisualization>
          <StrikeZonePlanesGraphic enabledPlanes={enabledPlanes} />
          <PlaneSummary>
            <PlaneSummaryTitle data-testid='plane-summary-title'>{formatSectionCountLabel(enabledPlanes.length)}</PlaneSummaryTitle>
            <PlaneSummaryDescription data-testid='plane-summary-description'>
              {formatSectionsDescription(enabledPlanes)}
            </PlaneSummaryDescription>
          </PlaneSummary>
        </PlaneVisualization>
      </Wrapper>
    </StrikeZoneCalculationWrapper>
  );
});
